import { render, staticRenderFns } from "./FormButton.vue?vue&type=template&id=5cd81423&scoped=true"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"
import style0 from "./form-button.scss?vue&type=style&index=0&id=5cd81423&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd81423",
  null
  
)

export default component.exports